import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { FeedbackApi } from 'api';
import { IFeedback, SearchFeedbackFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchFeedbackFilterType, size = 30) {
  return useAuthInfiniteList<IFeedback>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => FeedbackApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
